﻿
// tslint:disable:max-line-length
import { ePerm } from "./enums";

export interface IMetaProperty {
    name?: string;
    type?: string;
    control?: string;
    source?: string;
    enumType?: string;
    default?: boolean;
    sticky?: boolean;
    permissions?: string[];
}

export const meta = {
    Configurator: {
        $name: "Configurator",
    },
    KineticSettings: {
        $name: "KineticSettings",
    },
    LayoutConfig: {
        $name: "LayoutConfig",
    },
    DbTable: {
        $name: "DbTable",
    },
    BuildType: {
        $name: "BuildType",
    },
    Channel: {
        $name: "Channel",
    },
    Company: {
        $name: "Company",
    },
    Contact: {
        $name: "Contact",
    },
    CustomAction: {
        $name: "CustomAction",
    },
    Customer: {
        $name: "Customer",
    },
    EmailTemplate: {
        $name: "EmailTemplate",
    },
    Generator: {
        $name: "Generator",
    },
    GlobalDefinition: {
        $name: "GlobalDefinition",
    },
    GlobalFunction: {
        $name: "GlobalFunction",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        description: { name: "description", type: "text", control: "none", source: "none"},
        returnType: { name: "returnType", type: "text", control: "none", source: "none"},
        dynamicTypeJson: { name: "dynamicTypeJson", type: "text", control: "none", source: "none"},
        functionType: { name: "functionType", type: "text", control: "none", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "none", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
    },
    Job: {
        $name: "Job",
        type: { name: "type", type: "text", control: "select", source: "enum", default: true, enumType: "eJobType"},
        status: { name: "status", type: "text", control: "select", source: "enum", enumType: "eJobStatus"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        completedDate: { name: "completedDate", type: "text", control: "dateRange", source: "none"},
    },
    KbRole: {
        $name: "KbRole",
    },
    KbUserEdit: {
        $name: "KbUserEdit",
        id: { name: "id", type: "number", control: "none", source: "none"},
        firstName: { name: "firstName", type: "text", control: "none", source: "none"},
        lastName: { name: "lastName", type: "text", control: "none", source: "none"},
        email: { name: "email", type: "text", control: "none", source: "none"},
        isApproved: { name: "isApproved", type: "boolean", control: "checkbox", source: "none"},
        licenseType: { name: "licenseType", type: "text", control: "select", source: "enum", default: true, enumType: "eUserLicenseType"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none"},
        lastLoginDate: { name: "lastLoginDate", type: "text", control: "dateRange", source: "none"},
    },
    Layout: {
        $name: "Layout",
    },
    Log: {
        $name: "Log",
        type: { name: "type", type: "text", control: "select", source: "enum", default: true, enumType: "eLogType"},
        source: { name: "source", type: "text", control: "select", source: "enum", enumType: "eLogSource"},
    },
    Material: {
        $name: "Material",
    },
    MatTag: {
        $name: "MatTag",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
    },
    Notification: {
        $name: "Notification",
    },
    OutputBuilder: {
        $name: "OutputBuilder",
    },
    PriceColumn: {
        $name: "PriceColumn",
    },
    Product: {
        $name: "Product",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "suggest", source: "suggestProducts"},
        shortDescription: { name: "shortDescription", type: "text", control: "text", source: "none"},
        sku: { name: "sku", type: "text", control: "text", source: "none"},
        mfgPartNumber: { name: "mfgPartNumber", type: "text", control: "text", source: "none"},
        manufacturer: { name: "manufacturer", type: "text", control: "select", source: "manufacturers"},
        unitOfMeasure: { name: "unitOfMeasure", type: "text", control: "none", source: "none"},
        price: { name: "price", type: "number", control: "numberRange", source: "none"},
        maxQty: { name: "maxQty", type: "number", control: "none", source: "none"},
        minQty: { name: "minQty", type: "number", control: "none", source: "none"},
        allowFractionalQty: { name: "allowFractionalQty", type: "boolean", control: "none", source: "none"},
        score: { name: "score", type: "number", control: "none", source: "none"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
        isConfigured: { name: "isConfigured", type: "boolean", control: "none", source: "none"},
        images: { name: "images", type: "ProductImage[]", control: "none", source: "none"},
        templates: { name: "templates", type: "ProductTemplate[]", control: "none", source: "none"},
        translations: { name: "translations", type: "ProductTranslation[]", control: "none", source: "none"},
    },
    ProductHistory: {
        $name: "ProductHistory",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "suggest", source: "suggestProducts"},
        shortDescription: { name: "shortDescription", type: "text", control: "text", source: "none"},
        sku: { name: "sku", type: "text", control: "text", source: "none"},
        mfgPartNumber: { name: "mfgPartNumber", type: "text", control: "text", source: "none"},
        manufacturer: { name: "manufacturer", type: "text", control: "select", source: "manufacturers"},
        unitOfMeasure: { name: "unitOfMeasure", type: "text", control: "none", source: "none"},
        price: { name: "price", type: "number", control: "numberRange", source: "none"},
        maxQty: { name: "maxQty", type: "number", control: "none", source: "none"},
        minQty: { name: "minQty", type: "number", control: "none", source: "none"},
        allowFractionalQty: { name: "allowFractionalQty", type: "boolean", control: "none", source: "none"},
        score: { name: "score", type: "number", control: "none", source: "none"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
        isConfigured: { name: "isConfigured", type: "boolean", control: "none", source: "none"},
        images: { name: "images", type: "ProductImage[]", control: "none", source: "none"},
        templates: { name: "templates", type: "ProductTemplate[]", control: "none", source: "none"},
        translations: { name: "translations", type: "ProductTranslation[]", control: "none", source: "none"},
    },
    ProductImage: {
        $name: "ProductImage",
        id: { name: "id", type: "number", control: "none", source: "none"},
        imagePath: { name: "imagePath", type: "text", control: "none", source: "none"},
        imageOrder: { name: "imageOrder", type: "number", control: "none", source: "none"},
    },
    ProductRule: {
        $name: "ProductRule",
    },
    ProductTemplate: {
        $name: "ProductTemplate",
        id: { name: "id", type: "number", control: "none", source: "none"},
        templatePath: { name: "templatePath", type: "text", control: "none", source: "none"},
    },
    Queue: {
        $name: "Queue",
    },
    Quote: {
        $name: "Quote",
        id: { name: "id", type: "number", control: "none", source: "none"},
        state: { name: "state", type: "text", control: "multiSelect", source: "states", default: true},
        ownedBy: { name: "ownedBy", type: "number", control: "multiSelect", source: "users", default: true, permissions: [ePerm.viewUsers]},
        idCustomer: { name: "idCustomer", type: "number", control: "multiSelect", source: "customers", permissions: [ePerm.viewCustomers]},
        idContact: { name: "idContact", type: "number", control: "suggest", source: "suggestContacts", permissions: [ePerm.viewCustomers]},
        name: { name: "name", type: "text", control: "suggest", source: "suggestQuotes"},
        description: { name: "description", type: "text", control: "text", source: "none"},
        currency: { name: "currency", type: "text", control: "none", source: "none"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none"},
        owner: { name: "owner", type: "text", control: "none", source: "none"},
        customer: { name: "customer", type: "text", control: "none", source: "none"},
        contact: { name: "contact", type: "text", control: "none", source: "none"},
        products: { name: "products", type: "QuoteProduct[]", control: "none", source: "none"},
        files: { name: "files", type: "QuoteFile[]", control: "none", source: "none"},
        totalPrice: { name: "totalPrice", type: "number", control: "numberRange", source: "none", permissions: [ePerm.viewPrices]},
    },
    QuoteFile: {
        $name: "QuoteFile",
        tags: { name: "tags", type: "Tag[]", control: "none", source: "none"},
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        source: { name: "source", type: "text", control: "none", source: "none"},
        status: { name: "status", type: "text", control: "none", source: "none"},
        filePath: { name: "filePath", type: "text", control: "none", source: "none"},
    },
    QuoteHeader: {
        $name: "QuoteHeader",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        description: { name: "description", type: "text", control: "none", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
    },
    QuoteOutput: {
        $name: "QuoteOutput",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        description: { name: "description", type: "text", control: "none", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "none", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
    },
    QuoteProduct: {
        $name: "QuoteProduct",
        id: { name: "id", type: "number", control: "none", source: "none"},
        idQuote: { name: "idQuote", type: "number", control: "none", source: "none"},
        quote: { name: "quote", type: "text", control: "none", source: "none"},
        currency: { name: "currency", type: "text", control: "none", source: "none"},
        isConfigured: { name: "isConfigured", type: "boolean", control: "none", source: "none"},
        price: { name: "price", type: "number", control: "numberRange", source: "none", permissions: [ePerm.viewPrices]},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none"},
        createdBy: { name: "createdBy", type: "number", control: "select", source: "users", permissions: [ePerm.viewUsers]},
        files: { name: "files", type: "QuoteProductFile[]", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "text", source: "none"},
        description: { name: "description", type: "text", control: "text", source: "none"},
        shortDescription: { name: "shortDescription", type: "text", control: "none", source: "none"},
        sku: { name: "sku", type: "text", control: "text", source: "none"},
        imagePath: { name: "imagePath", type: "text", control: "none", source: "none"},
        idParent: { name: "idParent", type: "number", control: "none", source: "none"},
        idMainParent: { name: "idMainParent", type: "number", control: "none", source: "none"},
    },
    RootUser: {
        $name: "RootUser",
        email: { name: "email", type: "text", control: "none", source: "none"},
    },
    SafeFunction: {
        $name: "SafeFunction",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        description: { name: "description", type: "text", control: "none", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "none", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
    },
    Scene: {
        $name: "Scene",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        description: { name: "description", type: "text", control: "none", source: "none"},
        modifiedBy: { name: "modifiedBy", type: "number", control: "none", source: "none"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none"},
        external: { name: "external", type: "boolean", control: "none", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
    },
    SnapAssistantFeedback: {
        $name: "SnapAssistantFeedback",
    },
    SsoGroupRoleMapping: {
        $name: "SsoGroupRoleMapping",
    },
    Table: {
        $name: "Table",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        description: { name: "description", type: "text", control: "none", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none"},
        source: { name: "source", type: "text", control: "select", source: "enum", enumType: "eTableExternalSource"},
        dbTable: { name: "dbTable", type: "text", control: "none", source: "none"},
    },
    Tag: {
        $name: "Tag",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
    },
    TestBuild: {
        $name: "TestBuild",
        id: { name: "id", type: "number", control: "none", source: "none"},
        idProduct: { name: "idProduct", type: "number", control: "none", source: "none"},
        idBuildType: { name: "idBuildType", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        status: { name: "status", type: "text", control: "select", source: "enum", enumType: "eBuildStatus"},
        creatorName: { name: "creatorName", type: "text", control: "none", source: "none"},
    },
    Theme: {
        $name: "Theme",
    },
    Workflow: {
        $name: "Workflow",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        description: { name: "description", type: "text", control: "none", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
        valid: { name: "valid", type: "boolean", control: "none", source: "none"},
        isDefault: { name: "isDefault", type: "boolean", control: "none", source: "none"},
    },
    WorkflowSelector: {
        $name: "WorkflowSelector",
    },
    SceneHistory: {
        $name: "SceneHistory",
        id: { name: "id", type: "number", control: "none", source: "none"},
        name: { name: "name", type: "text", control: "none", source: "none"},
        description: { name: "description", type: "text", control: "none", source: "none"},
        modifiedBy: { name: "modifiedBy", type: "number", control: "none", source: "none"},
        createdDate: { name: "createdDate", type: "text", control: "dateRange", source: "none"},
        modifiedDate: { name: "modifiedDate", type: "text", control: "dateRange", source: "none"},
        external: { name: "external", type: "boolean", control: "none", source: "none"},
        modifiedByName: { name: "modifiedByName", type: "text", control: "none", source: "none"},
    },
    FeedbackRequest: {
        $name: "FeedbackRequest",
    },
    SnapConversation: {
        $name: "SnapConversation",
    },
};